import { decodeToken, getAccessToken } from '../auth0Access';
import { AppDispatch } from '../store';
import { actions } from './authorization.reducer';

const updateTokenData = () => {
  return async (dispatch: AppDispatch) => {
    dispatch(actions.fetchUserAccessRequest());
    try {
      const token = await getAccessToken();
      const tokenPayload = decodeToken(token);
      dispatch(actions.fetchUserAccessSuccess({ tokenPayload }));
    } catch (error: any) {
      dispatch(actions.fetchUserAccessFailure({ error: error?.message }));
    }
  };
};

const { setToken, clearToken, setPermissions } = actions;

/* eslint-disable import/prefer-default-export */
export { clearToken, setPermissions, setToken, updateTokenData };
